import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ConfigProvider, Spin } from "antd";
import { authService } from "./services/authService";
import { publicRoutes, authRoutes } from "./routes";
import ProtectedRoute from "./routes/ProtectedRoute";
import MainLayout from "./components/layout/MainLayout";
import AuthLayout from "./components/layout/AuthLayout";
import GuestSubmit from "./pages/guest/SubmitTestimonial";
import Unauthorized from "./pages/error/Unauthorized";

function App() {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [userCompanyId, setUserCompanyId] = useState(null); // NEW

  useEffect(() => {
    // Check authentication status on app load
    const checkAuth = () => {
      const authenticated = authService.isAuthenticated();
      setIsAuthenticated(authenticated);
      setUserRole(localStorage.getItem("userRole"));
      setUserCompanyId(localStorage.getItem("companyId")); // NEW
      setLoading(false);
    };

    checkAuth();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spin size="large" />
      </div>
    );
  }

  // Helper function to determine dashboard redirect
  const getDashboardRedirect = () => {
    switch (userRole) {
      case "super_admin":
      case "admin":
        return "/admin/dashboard";
      case "user":
        return "/user/dashboard";
      default:
        return "/login";
    }
  };

  return (
    <ConfigProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Navigate to="/login" replace />} />

          {/* Auth routes (login, verification) */}
          {authRoutes.map((route, idx) => (
            <Route
              key={idx}
              path={route.path}
              element={
                !isAuthenticated ? (
                  <AuthLayout>{route.element}</AuthLayout>
                ) : (
                  <Navigate to={getDashboardRedirect()} replace />
                )
              }
            />
          ))}

          {/* Protected routes */}
          {publicRoutes.map((route, idx) => {
            let element = route.element;

            // Add protection to admin routes
            if (route.path.includes("/admin")) {
              element = (
                <ProtectedRoute allowedRoles={["super_admin", "admin"]}>
                  {" "}
                  {/* UPDATED */}
                  <MainLayout>{route.element}</MainLayout>
                </ProtectedRoute>
              );
            }

            // Add protection to user routes
            if (route.path.includes("/user")) {
              element = (
                <ProtectedRoute allowedRoles={["super_admin", "admin", "user"]}>
                  {" "}
                  {/* UPDATED */}
                  <MainLayout>{route.element}</MainLayout>
                </ProtectedRoute>
              );
            }

            // Unauthorized page doesn't need layout
            if (route.path === "/unauthorized") {
              element = route.element;
            }

            return <Route key={idx} path={route.path} element={element} />;
          })}

          {/* Guest routes (no protection) */}
          <Route
            path="/guest-submit/:token"
            element={
              <AuthLayout>
                <GuestSubmit />
              </AuthLayout>
            }
          />

          {/* NEW: Companies route for super_admin only */}
          <Route
            path="/admin/companies"
            element={
              <ProtectedRoute allowedRoles={["super_admin"]}>
                <MainLayout>
                  {/* You'll create Companies component */}
                </MainLayout>
              </ProtectedRoute>
            }
          />

          {/* Catch all route - redirect to appropriate dashboard */}
          <Route
            path="*"
            element={
              isAuthenticated ? (
                <Navigate to={getDashboardRedirect()} replace />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
